// extracted by mini-css-extract-plugin
export default {"spinnerMain":"spinner_spinnerMain__rlJ7c"};